/* ──────────────────────────────────────────────
   WooCommerce plan: the self-service application and the
   price line shown on the homepage and in the plugin guide.
   Keep in step with the Order Form price plan
   (WOO-ECOM-LR-2026-10), the onboarding portal and the
   plugin readme.
   ────────────────────────────────────────────── */
export const WOO_APPLY_URL = "https://onboarding.paybank2bank.io/apply/woocommerce";
export const WOO_APPLY_LABEL = "onboarding.paybank2bank.io/apply/woocommerce";
export const WOO_PLAN_PRICING =
  "£150 per month including 300 transactions, then £0.50 per transaction; cancel with 30 days' notice";
export const WOO_PLAN_VAT_NOTE = "Prices exclude VAT.";
